export const actions = {
  read: 'read',
  edit: 'update',
  add: 'create',
  delete: 'delete',
  all: 'manage',
  listView: 'read',
  generate: 'generate',
};
export const subjects = {
  ride: 'Trip',
  rider: 'Passenger',
  location: 'AccountLocation',
  calendar: 'Calendar',
  settings: 'AccountSetting',
  billingDocument: 'billing_document',
  reports: 'Reports',
  dashboard: 'dashboard',
  downloadableDocument: 'DownloadableDocument',
  organizer: 'Organizer',
  onsiteStaff: 'onsite_staff',
  recording: 'DeviceRecording',
  clientReport: 'ClientReport',
};
